import React from "react";

export default function FooterAdmin() {
  return (
    <footer className="px-8 py-4 mt-auto" style={{ borderTop: "1px solid var(--color-border)" }}>
      <p className="text-xs text-center md:text-left" style={{ color: "var(--color-text-muted)" }}>
        &copy; {new Date().getFullYear()} S R R Enterprise. All rights reserved.
      </p>
    </footer>
  );
}
